import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "card mb-4 wizard-card",
  style: {}
}
const _hoisted_2 = { class: "wizard-card-bg-svg" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "text-muted fw-bold fs-7" }
const _hoisted_7 = {
  class: "stepper stepper-links d-flex flex-column",
  id: "kt_create_account_stepper",
  ref: "horizontalWizardRef"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-nav\"><div class=\"stepper-item current\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"></h3><h3 class=\"stepper-line\"></h3></div><div class=\"stepper-item pending\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"></h3><h3 class=\"stepper-line\"></h3></div><div class=\"stepper-item pending\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"></h3><h3 class=\"stepper-line\"></h3></div><div class=\"stepper-item pending\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"></h3><h3 class=\"stepper-line\"></h3></div><div class=\"stepper-item pending\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"></h3><h3 class=\"stepper-line\"></h3></div><div class=\"stepper-item pending\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"></h3><h3 class=\"stepper-line\"></h3></div><div class=\"stepper-item pending last\" data-kt-stepper-element=\"nav\"><h3 class=\"stepper-title\"></h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" style=\"display:none;\"><h3 class=\"stepper-title\"></h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" style=\"display:none;\"><h3 class=\"stepper-title\"></h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" style=\"display:none;\"><h3 class=\"stepper-title\"></h3></div><div class=\"stepper-item\" data-kt-stepper-element=\"nav\" style=\"display:none;\"><h3 class=\"stepper-title\"></h3></div></div>", 1)
const _hoisted_9 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_10 = { "data-kt-stepper-element": "content" }
const _hoisted_11 = { "data-kt-stepper-element": "content" }
const _hoisted_12 = { "data-kt-stepper-element": "content" }
const _hoisted_13 = { "data-kt-stepper-element": "content" }
const _hoisted_14 = { "data-kt-stepper-element": "content" }
const _hoisted_15 = { "data-kt-stepper-element": "content" }
const _hoisted_16 = { "data-kt-stepper-element": "content" }
const _hoisted_17 = { "data-kt-stepper-element": "content" }
const _hoisted_18 = { "data-kt-stepper-element": "content" }
const _hoisted_19 = { "data-kt-stepper-element": "content" }
const _hoisted_20 = { class: "mr-2" }
const _hoisted_21 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_22 = { class: "indicator-label" }
const _hoisted_23 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_24 = { class: "indicator-progress" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_26 = { class: "svg-icon svg-icon-4 ms-1 me-0" }
const _hoisted_27 = { class: "mt-2 p-4 rounded-3 bg-white" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-2" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/media/users/amanda.png",
      style: {"width":"170px","border-radius":"10px"}
    })
  ])
], -1)
const _hoisted_30 = { class: "col-lg-9" }
const _hoisted_31 = { class: "text-gray-400 fw-bold fs-6 mb-4 mt-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "link-primary fw-bolder",
  style: {"margin-right":"0px"}
}, [
  /*#__PURE__*/_createElementVNode("img", { src: "/media/svg/misc/lightbulb.svg" })
], -1)
const _hoisted_33 = { class: "fw-bolder d-flex text-dark mb-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-quote-left me-5",
  style: {"color":"#f2994a","font-size":"24px"},
  "data-bs-toggle": "tooltip"
}, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-quote-right ms-2",
  style: {"color":"#f2994a","font-size":"24px"},
  "data-bs-toggle": "tooltip"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 mb-1" }, "Amanda Huttis", -1)
const _hoisted_37 = { class: "text-gray-400" }
const _hoisted_38 = {
  class: "d-none",
  for: "referred_type"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  name: "referred_type",
  id: "referred_type",
  class: "d-none",
  value: "Patient Platform"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-none",
  for: "form_language"
}, "form_language", -1)
const _hoisted_41 = ["value"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-none",
  for: "mbi_products"
}, "mbi_products", -1)
const _hoisted_43 = ["value"]
const _hoisted_44 = {
  class: "d-none",
  for: "email"
}
const _hoisted_45 = {
  class: "d-none",
  for: "firstname"
}
const _hoisted_46 = {
  class: "d-none",
  for: "lastname"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-none",
  for: "date_of_birth"
}, "date of birth", -1)
const _hoisted_48 = {
  class: "d-none",
  for: "phone"
}
const _hoisted_49 = {
  class: "d-none",
  for: "gender"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-none",
  for: "initial_report_request_platform"
}, "initial_report_request_platform", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  name: "initial_report_request_platform",
  id: "initial_report_request_platform",
  class: "d-none",
  value: "1"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MBloader = _resolveComponent("MBloader")!
  const _component_Step1 = _resolveComponent("Step1")!
  const _component_Step2 = _resolveComponent("Step2")!
  const _component_Step3 = _resolveComponent("Step3")!
  const _component_Step4 = _resolveComponent("Step4")!
  const _component_Step5 = _resolveComponent("Step5")!
  const _component_Step6 = _resolveComponent("Step6")!
  const _component_Step7 = _resolveComponent("Step7")!
  const _component_Step8 = _resolveComponent("Step8")!
  const _component_ReportReady = _resolveComponent("ReportReady")!
  const _component_MedicalRecordStep = _resolveComponent("MedicalRecordStep")!
  const _component_ReportReadyCtms = _resolveComponent("ReportReadyCtms")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MBloader, { MedicalRecordsTableLoaded: _ctx.isLoaded }, null, 8, ["MedicalRecordsTableLoaded"]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["card-header border-0 py-5 card-wizard-hide", { 'ps-5': _ctx.ismobile }])
      }, [
        _createElementVNode("h3", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t("Explore Clinical Trials")) + " ", 1),
            _createElementVNode("i", {
              class: "fas fa-exclamation-circle ms-2 fs-7",
              "data-bs-toggle": "tooltip",
              title: _ctx.$t('ClinicalTrialDisclaimer')
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(
              "This online assessment takes only 2 minutes. It will help you find the right clinical trials for you."
            )), 1)
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["card-header border-0 py-5", { 'ps-5': _ctx.ismobile }])
      }, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("form", {
            class: "mx-auto w-100 pt-15 pb-10",
            novalidate: "novalidate",
            id: "kt_update_account_form",
            onSubmit: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Step1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Step2)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Step3)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Step4)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Step5)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_Step6, { current_phone: _ctx.current_phone }, null, 8, ["current_phone"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_Step7)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Step8)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_ReportReady, { trial_num: _ctx.trial_num }, null, 8, ["trial_num"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_MedicalRecordStep)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_ReportReadyCtms, { trial_num: _ctx.trial_num }, null, 8, ["trial_num"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["flex-stack mb-4 action_area", { 'd-flex': !_ctx.ismobile, 'mt-3': _ctx.ismobile }])
            }, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-lg btn-light-primary btn-sm me-3", { 'w-100': _ctx.ismobile }]),
                  "data-kt-stepper-action": "previous",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
                }, [
                  _createElementVNode("span", _hoisted_21, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("Back")), 1)
                ], 2)
              ]),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("button", {
                  type: "submit",
                  class: _normalizeClass(["btn btn-lg btn-primary me-3 btn-sm", { 'w-100 btn-sm': _ctx.ismobile }]),
                  style: {"display":"block"},
                  "data-kt-stepper-action": "submit"
                }, [
                  _createElementVNode("span", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Submit")) + " ", 1),
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_24, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Please wait")) + "... ", 1),
                    _hoisted_25
                  ])
                ], 2), [
                  [_vShow, !_ctx.nextshow]
                ]),
                _withDirectives(_createElementVNode("button", {
                  type: "submit",
                  class: _normalizeClass(["btn btn-lg btn-primary ctmscolor_background", { 'w-100 btn-sm': _ctx.ismobile }])
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("Next")) + " ", 1),
                  _createElementVNode("span", _hoisted_26, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr064.svg" })
                  ])
                ], 2), [
                  [_vShow, _ctx.nextshow]
                ])
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("Why are we asking this?")), 1)
                  ]),
                  _createElementVNode("h2", _hoisted_33, [
                    _hoisted_34,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(
                        "We ask this to determine which clinical trials you may be eligible for."
                      )) + " ", 1),
                    _hoisted_35
                  ]),
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("Massive Bio Clinical Nurse")), 1)
                ])
              ])
            ], 512), [
              [_vShow, !_ctx.ismobile]
            ]),
            _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("referred type")), 1),
            _hoisted_39,
            _hoisted_40,
            _createElementVNode("input", {
              type: "text",
              name: "form_language",
              id: "form_language",
              class: "d-none",
              value: _ctx.currentLocale.toUpperCase()
            }, null, 8, _hoisted_41),
            _hoisted_42,
            _createElementVNode("input", {
              type: "text",
              name: "mbi_products",
              id: "mbi_products",
              class: "d-none",
              value: _ctx.currentLocale === 'en' ? 'CTMS' : 'CTMS - International'
            }, null, 8, _hoisted_43),
            _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("email")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "email",
              id: "email",
              class: "d-none",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email_field) = $event))
            }, null, 512), [
              [_vModelText, _ctx.email_field]
            ]),
            _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t("First Name")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "firstname",
              id: "first_name",
              class: "d-none",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.first_name_field) = $event))
            }, null, 512), [
              [_vModelText, _ctx.first_name_field]
            ]),
            _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("Last Name")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "lastname",
              id: "last_name",
              class: "d-none",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.last_name_field) = $event))
            }, null, 512), [
              [_vModelText, _ctx.last_name_field]
            ]),
            _hoisted_47,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "date_of_birth",
              id: "date_of_birth",
              class: "d-none",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.date_of_birth_field) = $event))
            }, null, 512), [
              [_vModelText, _ctx.date_of_birth_field]
            ]),
            _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t("Phone")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "phone",
              id: "phone",
              class: "d-none",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.phone_field) = $event))
            }, null, 512), [
              [_vModelText, _ctx.phone_field]
            ]),
            _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t("Gender")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "gender",
              id: "gender",
              class: "d-none",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.gender_field) = $event))
            }, null, 512), [
              [_vModelText, _ctx.gender_field]
            ]),
            (_ctx.currentStepIndex >= 6)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_50,
                  _hoisted_51
                ], 64))
              : _createCommentVNode("", true)
          ], 32)
        ], 512)
      ], 2)
    ], 512), [
      [_vShow, _ctx.isLoaded]
    ])
  ]))
}